import { useEffect, useState } from 'react';
import { getAnalyticsToken } from 'redux/actions/analytics';
import { AnalyticsDashBoardType } from 'redux/schemas/app/analytics';
import { useAppDispatch } from 'redux/store';
import useIsMounted from 'shared/hooks/use-is-mounted';

const useLoadToken = (props) => {
  const { type, catalogId, institutionId, pageIdKey, scenarioId, questionSetId, cohortCourseIds, programId } = props;
  const [tokenData, setTokenData] = useState(null);
  const isMounted = useIsMounted();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleToken = (data) => {
      if (isMounted()) {
        setTokenData(data.payload);
      }
    };

    if (type === AnalyticsDashBoardType.LEARNING_JOURNEY) {
      dispatch(getAnalyticsToken({ journeyCatalogId: catalogId, institutionId, type })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.INSTITUTION) {
      dispatch(getAnalyticsToken({ institutionId, type })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.COURSE || type === AnalyticsDashBoardType.COHORTS) {
      dispatch(getAnalyticsToken({ institutionId, catalogId, type })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.LICENSE) {
      dispatch(getAnalyticsToken({ institutionId, type, pageIdKey })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.QUESTION_SET) {
      dispatch(getAnalyticsToken({
        type,
        institutionId,
        catalogId,
        questionSetId,
      })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.COHORT_QUESTION_SET) {
      dispatch(getAnalyticsToken({
        type,
        institutionId,
        catalogId,
        questionSetId,
        cohortCourseIds,
      })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.PRACTICE_ANALYTICS) {
      dispatch(getAnalyticsToken({ institutionId, type, scenarioId })).then(handleToken);
    }
    if (type === AnalyticsDashBoardType.MENTORSHIP_PROGRAM) {
      dispatch(getAnalyticsToken({ institutionId, type, programId })).then(handleToken);
    }
  }, [questionSetId, cohortCourseIds]);

  return tokenData;
};

export default useLoadToken;
